import React from "react";

function DisclaimerPage() {
  return (
    <main className="disclaimer-page">
      <section className="disclaimer-card">

        <h1>DISCLAIMER</h1>

        <p>
          This website provides aviation-related calculators and tools for
          informational and educational purposes only. While reasonable efforts 
          are made to provide accurate calculations, no guarantee is made regarding 
          the accuracy, completeness, or reliability of any information provided.
        </p>

        <h2>NO FLIGHT PLANNING OR OPERATIONAL USE</h2>

        <p>
          This application is not intended to be used for flight planning, 
          operational decision-making, or real-world aviation use.<br></br>
          It must not be used as a primary source for navigation, performance calculations, 
          or safety-critical decisions.<br></br>

          Pilots must consult official FAA publications, approved flight planning tools, 
          aircraft operating handbooks (POH/AFM), and current weather briefings before 
          conducting any flight.
        </p>

        <h2>LIMITATION OF LIABILITY</h2>

        <p>
          Use of this application is at your own risk. Under no circumstances shall 
          the owner or developer be liable for any loss, damage, injury, 
          or other consequences resulting from the use of, or reliance on, 
          this website or its calculations.

        </p>

      
        <h2>EXTERNAL LINKS</h2>

        <p>
          This site may contain links to third-party websites. These links are
          provided for convenience only. No responsibility is assumed for the
          content, accuracy, reliability, or availability of any external
          website or third-party source.
        </p>

        <h2>PROFESSIONAL DISCLAIMER</h2>

        <p>
          The information provided on this site does not constitute aviation
          instruction, professional advice, certification, or authorization to
          operate an aircraft. Users should seek guidance from qualified aviation
          professionals, including certified flight instructors or other
          authorized personnel, when appropriate.

        </p>
  

      </section>
    </main>
  );
}

export default DisclaimerPage;